import { DocumentNode, QueryHookOptions, gql } from '@apollo/client';
import { CampaignId } from 'modules/domains/campaign';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';

export const queryExpectedSendSize = gql`
  query getExpectedSendSize($id: Long!) {
    campaign: campaign(id: $id) {
      id
      expectedSendSize
    }
  }
`;

export type ExpectedSendSize = number | null | undefined;

export type QueryExpectedSendSizeRequest = {
  id: CampaignId;
};

export const useQueryExpectedSendSize = (
  options: Record<string, any>,
  query: DocumentNode = queryExpectedSendSize,
) => {
  const dispatch = useDispatch();

  const queryOptions: QueryHookOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      onError: (error) => {
        const errorMessage = `Error fetching selected list sizes. Please try again later.`;
        dispatch(addNegativeToastWithErrorId(errorMessage, 'useQueryExpectedSendSize', error));
      },
      ...options,
    }),
    [options],
  );

  const {
    data,
    isLoading,
    isLoading: isFetching,
    error: hasError,
    refetch,
  } = useGraphql(query, queryOptions);
  const sendSize = data?.campaign?.expectedSendSize as ExpectedSendSize;

  return {
    isFetching,
    isLoading,
    sendSize,
    hasError,
    refetch,
  };
};
